import PageContainer from "../components/PageContainer";
import { Helmet } from 'react-helmet-async';

const UserTermsAndConditions = () => {
    return (
        <PageContainer items="center" px="4">
            <Helmet>
                <title>Termini e condizioni - TicinoWild</title>
                <meta name="description" content="Termini e condizioni generali di utilizzo della piattaforma TicinoWild, registrazione, prenotazioni e informativa sulla privacy." />
                <link rel="canonical" href="https://ticinowild.ch/terms-and-conditions" />
                <meta property="og:title" content="Termini e condizioni - TicinoWild" />
                <meta property="og:description" content="Termini e condizioni generali di utilizzo della piattaforma TicinoWild, registrazione, prenotazioni e informativa sulla privacy." />
                <meta property="og:url" content="https://ticinowild.ch/terms-and-conditions" />
                <meta name="twitter:title" content="Termini e condizioni - TicinoWild" />
                <meta name="twitter:description" content="Termini e condizioni generali di utilizzo della piattaforma TicinoWild, registrazione, prenotazioni e informativa sulla privacy." />
            </Helmet>
            <div className="flex flex-col gap-8 max-w-[600px] mt-8 terms">
                <h3 className="font-normal">Condizioni generali</h3>
                <div>
                    <h4 className="text-[#225424]">1. Informazioni generali</h4>
                    <p>
                        TicinoWild è una piattaforma di informazione accessibile sul sito web www.ticinowild.ch, la quale
                        offre una panoramica di attività outdoor da fare in Ticino pensate per diverse fasce di utenti.
                        TicinoWild è al contempo una piattaforma di intermediazione e prenotazione che consente la
                        prenotazione di attività offerte da fornitori terzi e serve a intermediare l’acquisto di servizi nel
                        settore del tempo libero e dello sport. Il pagamento delle attività avviene tramite Stripe Connect,
                        che consente la gestione automatizzata dei pagamenti e la ripartizione degli importi tra TicinoWild
                        e i fornitori terzi.
                    </p>
                    <p>
                        L'uso della piattaforma TicinoWild, inclusa la creazione di un account, è gratuito e presuppone solo la
                        consultazione dei contenuti proposti da TicinoWild sul suo sito web.
                        TicinoWild propone sia attività gratuite sia a pagamento. Le attività a pagamento (di seguito
                        denominate anche “servizi”) sono fornite da terze parti (di seguito denominate anche “Partner
                        fornitori”, “Fornitori esterni” o “Fornitori di terze parti”) e sono prenotabili tramite il sito di TicinoWild,
                        dietro pagamento del prezzo dell’attività. Il prezzo delle attività a pagamento dipende da diversi fattori,
                        come ad esempio il numero di partecipanti, ed è indicato al momento della prenotazione.
                    </p>
                    <p>
                        Tra TicinoWild e l'Utente della piattaforma valgono le seguenti Condizioni Generali di Contratto (di
                        seguito “CG”). Le CG si applicano al contratto quadro stipulato con TicinoWild al momento della
                        registrazione dell'Utente.
                    </p>
                </div>




                <div>
                    <h4 className="text-[#225424]">2. Registrazione / Utilizzo</h4>
                    <p>
                        Solo le persone fisiche e le persone giuridiche e le società di persone con capacità giuridica illimitata
                        possono registrarsi e utilizzare la piattaforma.
                    </p>
                    <p>
                        Per accedere a determinate funzionalità della piattaforma, l'Utente deve creare un account. Durante
                        la fase di registrazione viene richiesto all’Utente di fornire un indirizzo e-mail valido. Per usufruire di
                        servizi quali la prenotazione di attività a pagamento o l’acquisto di articoli tramite lo shop, all’Utente
                        viene richiesto di fornire ulteriori informazioni (come ad esempio i dati di contatto). L'utente è tenuto a
                        fornire informazioni corrette, aggiornate e complete.
                    </p>
                    <p>
                        L'Utente è il solo responsabile dell'attività che si verifica sul proprio account ed è tenuto a proteggerlo.
                        A tal fine, accetta di mantenere aggiornate le proprie informazioni di contatto.
                        TicinoWild declina ogni responsabilità rispetto all’Utente o a terzi in caso di transazioni non
                        autorizzate effettuate con l’uso della password o dell’account dell’Utente.
                    </p>
                    <p>
                        Per registrarsi, acquistare sullo shop e prenotare servizi, l’Utente deve aver letto, compreso e accettato
                        le presenti CG e confermare di aver preso atto dell'informativa sulla Privacy. Cliccando sul pulsante “Ho
                        letto e compreso i Termini e le condizioni” in fase di registrazione, l’Utente dichiara di aver letto,
                        compreso e accettato le presenti CG e l’informativa sulla Privacy di TicinoWild.
                    </p>
                </div>




                <div>
                    <h4 className="text-[#225424]">3. Conto TicinoWild</h4>
                    <p>
                        Al momento della registrazione e quindi della stipula del contratto quadro, l'Utente riceve l'accesso al
                        proprio conto utente TicinoWild (di seguito “conto utente” o “account utente”).
                    </p>
                    <p>
                        L'Utente non può divulgare a terzi i dati di accesso del suo conto utente e deve mantenerlo protetto
                        dall'accesso di terzi non autorizzati. L'account utente non è trasferibile. Se l'Utente viola questa
                        disposizione, TicinoWild ha il diritto di bloccare l'account dell'Utente.
                    </p>
                </div>




                <div>
                    <h4 className="text-[#225424]">4. Durata e cancellazione</h4>
                    <p>
                        Il contratto quadro rimane valido fino a quando l’Utente non decide di disdirlo cancellando il proprio
                        conto utente, o fino a quando TicinoWild non lo annulla chiudendo il conto dell’Utente.
                    </p>
                    <p>
                        L’Utente può richiedere la cancellazione del suo account utente in qualsiasi momento attraverso la sua
                        pagina profilo.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">4.1. Procedura di cancellazione e periodo di riattivazione</h4>
                    <p>
                        A seguito della richiesta di cancellazione, l’account dell’Utente viene inizialmente disattivato.
                    </p>
                    <p>
                        Per un periodo di 14 giorni dalla richiesta, l’Utente ha la possibilità di riattivare il proprio account
                        effettuando nuovamente l’accesso alla piattaforma. Durante questo periodo, i dati restano associati
                        all’account per consentirne il ripristino.
                    </p>
                    <p>
                        Trascorso il periodo di 14 giorni senza riattivazione, l’account viene considerato definitivamente
                        cancellato e non più recuperabile.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">4.2. Effetti della cancellazione</h4>
                    <p>A seguito della cancellazione definitiva dell’account:</p>
                    <ul className="list-disc pl-5">
                        <li>l’accesso alla piattaforma viene disabilitato in modo permanente</li>
                        <li>i dati personali non più necessari vengono cancellati o anonimizzati</li>
                        <li>i dati associati all’account non sono più accessibili all’Utente</li>
                    </ul>
                </div>

                <div>
                    <h4 className="text-[#225424]">4.3. Conservazione dei dati per obblighi legali</h4>
                    <p>
                        Restano esclusi dalla cancellazione i dati che TicinoWild è tenuta a conservare per obblighi legali o
                        contrattuali.
                    </p>
                    <p>
                        In particolare, i dati relativi a transazioni, prenotazioni, fatture e pagamenti possono essere conservati
                        per un periodo fino a 10 anni, conformemente al diritto svizzero.
                    </p>
                    <p>
                        Tali dati sono conservati in modo limitato e protetto (c.d. “archiviazione” o “congelamento”), e sono
                        utilizzati esclusivamente per adempiere agli obblighi legali e fiscali.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">4.4. Prenotazioni esistenti</h4>
                    <p>
                        Se l’Utente cancella il proprio account, tutte le prenotazioni già confermate e non ancora svolte
                        restano valide e devono essere eseguite secondo gli accordi con il fornitore terzo. In tali casi, il rapporto
                        contrattuale relativo alle singole attività rimane in essere tra Utente e fornitore fino al completamento
                        delle prestazioni. La cancellazione dell’account non incide sui contratti già conclusi e non pregiudica
                        l’invio e la validità delle comunicazioni operative relative alle prenotazioni in corso.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">4.5. Cancellazione da parte di TicinoWild</h4>
                    <p>
                        TicinoWild può risolvere il contratto quadro in via straordinaria e senza preavviso e/o negare all'Utente
                        l'accesso alla piattaforma TicinoWild se l'Utente ha materialmente violato gli obblighi previsti dalle
                        presenti CG, se l'Utente ha violato le leggi, i regolamenti o i diritti di terzi applicabili, o se tale azione è
                        necessaria e appropriata per proteggere la sicurezza di terzi o la proprietà dei fornitori.
                    </p>
                    <p>
                        Tranne nel caso di violazioni gravi, TicinoWild, per quanto possibile e opportuno, annuncerà un
                        provvedimento e darà all'Utente la possibilità di porre rimedio alla violazione.
                    </p>
                    <p>
                        Dopo l'annullamento del contratto quadro, non sussiste alcun diritto al ripristino dell'account utente.
                    </p>
                </div>




                <div>
                    <h4 className="text-[#225424]">5. Attività gratuite</h4>
                    <p>
                        Le attività gratuite sono a puro scopo informativo e non possono essere prenotate tramite la
                        piattaforma TicinoWild.
                    </p>
                    <p>
                        Alcune attività gratuite presuppongono il pagamento di mezzi di trasporto per raggiungere il luogo
                        dell’attività. Se non espressamente indicato, TicinoWild non ha alcuna relazione o convenzione con
                        questo tipo di fornitori, pertanto i loro servizi non possono essere prenotati tramite la piattaforma.
                    </p>
                </div>



                <div>
                    <h4 className="text-[#225424]">6. Prenotazione presso fornitori di terze parti attraverso TicinoWild</h4>
                    <p>
                        L'Utente può utilizzare la piattaforma per prenotare servizi e attività per il tempo libero, forniti dai
                        partner fornitori di TicinoWild. Queste attività sono a pagamento.
                    </p>
                    <p>
                        TicinoWild non è il fornitore delle attività proposte sulla piattaforma, non organizza né esegue tali
                        attività e non assume alcuna responsabilità per la loro realizzazione materiale o per la loro corretta
                        esecuzione.
                    </p>
                    <p>
                        TicinoWild opera come piattaforma digitale di intermediazione (marketplace) che mette in contatto
                        Utenti e fornitori terzi indipendenti per la prenotazione di attività. TicinoWild non è parte del contratto
                        relativo all’esecuzione delle attività, ma agisce unicamente quale intermediario tecnico e di
                        pagamento. Per tali servizi di intermediazione, TicinoWild percepisce una commissione di piattaforma.
                    </p>
                    <p>
                        Il contratto relativo alla prestazione dell’attività si conclude esclusivamente tra l’Utente e il fornitore
                        terzo indipendente. TicinoWild non è parte di tale rapporto contrattuale per quanto riguarda
                        l’organizzazione, l’esecuzione o la qualità del servizio. TicinoWild non garantisce la qualità, la sicurezza
                        o la conformità delle attività offerte dai fornitori terzi.
                    </p>
                    <p>
                        TicinoWild può eventualmente svolgere attività di promozione e facilitazione della visibilità delle
                        attività offerte dai fornitori terzi, senza che ciò comporti alcuna assunzione di responsabilità in merito
                        ai servizi offerti.
                    </p>
                    <p>
                        Effettuando una prenotazione presso un fornitore di terze parti tramite la piattaforma, l’Utente
                        riconosce e accetta di leggere ed essere vincolato dai termini e condizioni per l'acquisto e lo
                        svolgimento dell’attività acquistata, nonché dalla normativa sulla privacy del fornitore e da qualsiasi
                        altra regola o norma correlata alla struttura del fornitore. L’Utente riconosce che le attività sono fornite
                        da terzi indipendenti e accetta che i relativi rischi connessi all’esecuzione del servizio siano disciplinati
                        dal rapporto contrattuale con il fornitore. TicinoWild declina ogni responsabilità in merito ad azioni,
                        omissioni, errori, rappresentazioni, garanzie, violazioni o negligenza da parte di qualsiasi fornitore di
                        terze parti e in merito a lesioni personali, decesso, danni di proprietà o altri danni o spese risultanti
                        dalle interazioni dell'Utente con i fornitori di terze parti.
                    </p>
                    <p>
                        I diritti di ricorso in relazione a un contratto tra l'Utente e un fornitore di terze parti (ad esempio, in
                        relazione a rimborsi e cancellazioni) saranno da intendersi tra l'Utente e la terza parte in questione,
                        come stabilito nel contratto con quest'ultima.
                    </p>
                    <p>
                        Nell'improbabile eventualità in cui il servizio sia disponibile all'atto dell'ordine e del pagamento dello
                        stesso ma cessi di esserlo prima del suo svolgimento, l'unico rimedio concesso per risolvere la
                        questione tra l'Utente e TicinoWild è che l'Utente contatti il fornitore per prendere accordi alternativi o
                        per cancellare la prenotazione e ottenere un rimborso (ove applicabile e conformemente alla legge
                        vigente e al contratto stipulato con il fornitore di terze parti).
                    </p>
                </div>



                <div>
                    <h4 className="text-[#225424]">6.1. Processo di prenotazione</h4>
                    <p>
                        Al momento della prima prenotazione sulla piattaforma di TicinoWild, all’Utente viene richiesto di
                        inserire alcuni dati personali, tra cui i dati di contatto. L'Utente è tenuto a fornire informazioni corrette,
                        aggiornate e complete. Le informazioni vengono utilizzate per l'elaborazione del contratto di
                        intermediazione tra l’Utente e il fornitore esterno, in particolare per consentire l’organizzazione e il
                        corretto svolgimento dell’attività prenotata da parte del partner fornitore.
                        Le informazioni fornite dall’Utente rimangono memorizzate nel suo account utente personale per
                        prenotazioni future. L’Utente può visualizzare e modificare le informazioni in qualsiasi momento
                        tramite il suo profilo utente e prima di finalizzare una prenotazione.
                    </p>
                    <p>
                        Effettuando una prenotazione, l'Utente autorizza TicinoWild a stipulare contratti con i rispettivi
                        fornitori per conto dell'Utente e a condividere con i fornitori i dati necessari per l’organizzazione e il
                        corretto svolgimento dell’attività prenotata.
                        I partner fornitori di TicinoWild sono tenuti a utilizzare i dati personali dell’Utente esclusivamente ai
                        fini di conferma ed organizzazione dell’attività prenotata. Qualsiasi altro uso dei dati personali è
                        ritenuto improprio e costituisce una violazione degli obblighi contrattuali tra TicinoWild e i suoi
                        fornitori partner. Al più tardi entro 2 settimane dal termine dell’attività, i partner fornitori sono tenuti a
                        cancellare i dati dell’Utente.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">6.2. Completamento della prenotazione e conferma</h4>
                    <p>
                        Quando si effettua una prenotazione, l'Utente deve fornire i dati personali necessari. Tali dati, richiesti
                        di norma solo al momento della prima prenotazione, vengono memorizzati nel proprio account utente
                        per semplificare prenotazioni future. Queste informazioni sono fondamentali per garantire
                        l’organizzazione e il corretto svolgimento dell’attività prenotata.
                    </p>
                    <p>
                        Completando la procedura di prenotazione, l’Utente conferma l'esattezza dei dati personali.
                        L’Utente può modificare e visualizzare i dati in qualsiasi momento prima di finalizzare la prenotazione.
                    </p>
                    <p>
                        La prenotazione dell’Utente costituisce una richiesta di partecipazione all’attività. Il contratto tra
                        l’Utente e il fornitore terzo si considera concluso al momento dell’accettazione della richiesta da parte
                        del fornitore. Tuttavia, l’esecuzione dell’attività è subordinata al pagamento dell’importo dovuto da
                        parte dell’Utente.
                    </p>
                    <p>
                        Dopo aver completato la prenotazione, l’Utente riceve una conferma di ricezione della richiesta di
                        prenotazione, contenente i dati del fornitore esterno responsabile dell’offerta. È importante notare che
                        questa conferma di ricezione della richiesta di prenotazione non equivale a una conferma di
                        prenotazione definitiva. Di regola, entro 48h dall’invio della richiesta di prenotazione (e non più tardi di
                        24h prima dello svolgimento dell’attività), il fornitore esterno contatterà l’Utente per verificare la
                        richiesta e comunicare l’accettazione della prenotazione dell’attività. Con l’accettazione della
                        prenotazione, l’Utente riceverà anche le istruzioni per il pagamento.
                    </p>
                    <p>
                        Solo a seguito del pagamento l’Utente riceve la conferma definitiva e l’attività viene considerata
                        confermata ai fini operativi e organizzativi.
                    </p>
                    <p>
                        L’Utente è tenuto a saldare l’attività prima dell’inizio della stessa e, se richiesto dal fornitore partner,
                        dovrà fornire prova dell’avvenuto pagamento al momento dell'inizio dell’attività prenotata.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">6.3. Pagamento / Condizioni di pagamento</h4>
                    <p>
                        I pagamenti per le attività prenotate tramite la piattaforma vengono gestiti tramite Stripe Connect, che
                        agisce quale infrastruttura tecnica per l’elaborazione dei pagamenti e la ripartizione degli importi tra
                        TicinoWild e fornitore terzo, secondo le percentuali concordate. TicinoWild non incassa né detiene i
                        fondi dell’Utente in alcun momento. L’elaborazione e la distribuzione dei pagamenti avvengono
                        direttamente tramite Stripe.
                    </p>
                    <p>
                        TicinoWild opera come piattaforma digitale di intermediazione (marketplace) che mette in contatto
                        Utenti e fornitori terzi indipendenti per la prenotazione di attività. TicinoWild facilita la conclusione dei
                        contratti tra le parti e la gestione dei pagamenti tramite Stripe Connect, percependo una commissione
                        per i servizi di intermediazione forniti. Il contratto relativo all’attività si conclude direttamente tra
                        l’Utente e il fornitore terzo. TicinoWild non è parte del contratto relativo all’esecuzione del servizio, ma
                        fornisce esclusivamente servizi di intermediazione tecnica e di pagamento.
                    </p>
                    <p>
                        L'Utente paga il costo dell’attività prenotata come prezzo totale in franchi svizzeri (CHF) secondo i
                        prezzi applicabili al momento della prenotazione. TicinoWild è autorizzata a modificare in qualsiasi
                        momento i prezzi per le prenotazioni future.
                    </p>
                    <p>
                        Il pagamento dovrà essere effettuato entro l’inizio di svolgimento dell’attività prenotata utilizzando il
                        mezzo di pagamento indicato dall'Utente. L’Utente riceve le indicazioni per procedere al pagamento
                        all’interno della e-mail di accettazione della prenotazione.
                    </p>
                    <p>
                        Per la gestione dei pagamenti TicinoWild utilizza Stripe. Maggiori informazioni sulla privacy policy di
                        Stripe e sulla gestione dei cookie da parte del loro sito web è disponibile su www.stripe.com.
                    </p>
                    <p>
                        Il pagamento può essere effettuato tramite i metodi di pagamento indicati nella procedura di
                        pagamento su Stripe.
                    </p>
                    <p>
                        Eventuali costi associati al metodo di pagamento scelto o commissioni applicate (ad esempio per
                        tassi di cambio) dal fornitore del mezzo di pagamento scelto sono a carico dell’Utente.
                        L’Utente è considerato il solo responsabile per ogni prenotazione e pagamento effettuato tramite il
                        suo conto utente. TicinoWild declina ogni responsabilità per prenotazioni e pagamenti illeciti o non
                        autorizzati effettuati da parte di terzi dall’account personale dell’Utente. Tali prenotazioni e pagamenti
                        sono considerati da TicinoWild come effettuati da parte dell’Utente.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">6.4. Limitazione di responsabilità sui dati di pagamento</h4>
                    <p>
                        TicinoWild non ha accesso diretto ai dati di pagamento forniti dall’Utente durante il processo di
                        pagamento. Tutte le transazioni sono gestite tramite Stripe, una piattaforma di pagamento sicura e
                        certificata, che garantisce la protezione dei dati sensibili.
                    </p>
                    <p>
                        Di conseguenza, TicinoWild declina ogni responsabilità per eventuali furti, violazioni o utilizzi illeciti
                        dei mezzi di pagamento dell’Utente. Per qualsiasi problema relativo ai pagamenti, l’Utente è invitato a
                        contattare direttamente il gestore del proprio mezzo di pagamento.
                    </p>
                    <p>
                        Stripe può trattare i dati anche al di fuori della Svizzera o dello Spazio Economico Europeo secondo le
                        proprie condizioni.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">6.5. Prenotazione / Disponibilità del servizio</h4>
                    <p>
                        Le attività a pagamento di TicinoWild possono essere prenotate in qualsiasi momento. Per consentire
                        ai partner fornitori di verificare la richiesta di prenotazione e confermare la prenotazione dell’attività,
                        la prenotazione sul sito di TicinoWild deve essere effettuata almeno 48h ore prima dello svolgimento
                        dell’attività desiderata.
                    </p>
                    <p>
                        TicinoWild declina ogni responsabilità per richieste di prenotazione pervenute oltre i termini indicati o
                        per attività non effettuate a causa del mancato pagamento entro i tempi previsti da parte dell’Utente.
                    </p>
                    <p>
                        TicinoWild richiama l'attenzione dei fornitori sulla disponibilità e si adopera affinché questa sia
                        sempre garantita. Tuttavia, non può essere ritenuta responsabile per questo.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">6.6. Cancellazione</h4>
                    <p>
                        Le condizioni di cancellazione, modifica e rimborso applicabili alle attività prenotate tramite la
                        piattaforma sono stabilite dal singolo fornitore terzo e possono variare in base al tipo di attività.
                    </p>
                    <p>
                        È responsabilità dell’Utente consultare attentamente tali condizioni prima della prenotazione, in
                        quanto esse disciplinano il rapporto contrattuale tra Utente e fornitore. In caso di necessità, l’Utente
                        può contattare direttamente il fornitore per ulteriori chiarimenti sui termini applicabili.
                    </p>
                    <p>
                        Eventuali richieste di cancellazione o rimborso devono essere indirizzate direttamente al fornitore
                        terzo responsabile dell’attività.
                    </p>
                    <p>
                        TicinoWild non interviene nella gestione dei rimborsi e non garantisce il rimborso degli importi versati,
                        salvo nei casi in cui:
                    </p>
                    <ul className="list-disc pl-5">
                        <li>ciò sia previsto obbligatoriamente dalla legge applicabile, oppure</li>
                        <li>
                            il mancato servizio derivi da un malfunzionamento tecnico imputabile direttamente a TicinoWild
                            nella gestione della piattaforma o del pagamento.
                        </li>
                    </ul>
                    <p>
                        Resta inteso che i diritti inderogabili previsti dalla normativa applicabile rimangono in ogni caso validi
                        e non sono limitati dalle presenti condizioni.
                    </p>
                    <p>
                        In caso di cancellazione o mancata erogazione dell’attività da parte del fornitore, eventuali diritti o
                        richieste dell’Utente devono essere fatti valere direttamente nei confronti del fornitore, salvo quanto
                        diversamente previsto dalla legge.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">6.7. Attuazione generale</h4>
                    <p>
                        L'attività prenotata avrà luogo nel giorno e all'orario prenotati dall’Utente e confermati dal fornitore
                        esterno. L’Utente dovrà autenticarsi presso l'offerente presentando la conferma d'ordine e se
                        richiesto, la conferma di avvenuto pagamento.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">6.8. Svolgimento dell’attività / Responsabilità</h4>
                    <p>
                        TicinoWild funge esclusivamente da intermediario per prenotazione e pagamento tra l’Utente e il
                        partner fornitore. Durante lo svolgimento dell’attività vigono le norme e le condizioni del partner
                        fornitore.
                        L’Utente è tenuto al rispetto di tali norme e condizioni, che possono includere requisiti di
                        comportamento, regolamenti specifici dell’attività e eventuali misure di sicurezza. È responsabilità
                        dell’Utente informarsi e conformarsi a queste disposizioni, per garantire un’esperienza positiva e
                        senza intoppi. Si noti che in caso di inadempienza, il fornitore esterno potrebbe riservarsi il diritto di
                        annullare l’attività senza alcun rimborso.
                    </p>
                    <p>
                        TicinoWild esclude la responsabilità (compresa la responsabilità delle sue persone ausiliarie e dei
                        suoi dipendenti) per tutti i reclami derivanti da o in relazione alla piattaforma nella misura consentita
                        dalla legge. TicinoWild esclude la responsabilità nei limiti consentiti dalla legge, in particolare per
                        l’esecuzione delle attività da parte dei fornitori terzi, salvo i casi di dolo o colpa grave di TicinoWild.
                        TicinoWild sarà responsabile nei confronti dell'Utente solo per le proprie violazioni degli obblighi nel
                        processo di intermediazione e prenotazione (ad es. mancata disponibilità della piattaforma, guasto di
                        singole funzioni della piattaforma o malfunzionamento della piattaforma) e solo in caso di dolo o colpa
                        grave.
                    </p>
                    <p>
                        TicinoWild mette a disposizione dell'Utente la piattaforma per la prenotazione di servizi. TicinoWild
                        non è parte di questi contratti di intermediazione e non è responsabile del corretto adempimento del
                        contratto. L'Utente deve far valere tutti i diritti derivanti da e in relazione a tale contratto con il relativo
                        fornitore.
                    </p>
                    <p>
                        Inoltre, TicinoWild non è responsabile e non deve alcun rimborso se l'Utente non può svolgere
                        un’attività perché l’ha prenotata troppo tardi o non ha rispettato i termini di pagamento.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">6.9. Obblighi dell'utente</h4>
                    <p>
                        L'Utente deve sempre attenersi alle istruzioni del fornitore e deve comportarsi in modo rispettoso e
                        conforme nei confronti di terzi durante il consumo del servizio o l'utilizzo di qualsiasi attrezzatura del
                        fornitore. Deve inoltre presentarsi puntale e in condizioni idonee a garantire il corretto svolgimento
                        dell’attività.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">
                        6.10. Attività “TicinoWild Originals” (servizi forniti direttamente da TicinoWild)
                    </h4>
                    <p>
                        Oltre alle attività offerte da fornitori terzi indipendenti, la piattaforma TicinoWild può proporre attività,
                        esperienze o servizi organizzati e forniti direttamente da TicinoWild (di seguito “Attività TicinoWild
                        Originals”).
                    </p>
                    <p>
                        In tali casi, TicinoWild agisce quale fornitore diretto del servizio e il contratto relativo alla prestazione
                        dell’attività si conclude direttamente tra l’Utente e TicinoWild.
                    </p>
                    <p>Le presenti disposizioni si applicano esclusivamente alle Attività TicinoWild Originals:</p>
                    <ul className="list-disc pl-5">
                        <li>
                            TicinoWild è responsabile dell’organizzazione, della gestione e dell’esecuzione dell’attività, nei limiti
                            previsti dalla legge.
                        </li>
                        <li>
                            Eventuali condizioni specifiche dell’attività (ad esempio requisiti di partecipazione, sicurezza,
                            cancellazione o rimborso) possono essere indicate nella scheda descrittiva della singola attività e
                            costituiscono parte integrante del contratto.
                        </li>
                        <li>
                            Le condizioni di cancellazione e rimborso possono differire da quelle applicabili alle attività di
                            fornitori terzi.
                        </li>
                    </ul>
                    <p>
                        Resta inteso che TicinoWild può avvalersi di collaboratori, guide o fornitori ausiliari per l’esecuzione
                        delle Attività TicinoWild Originals, mantenendo in ogni caso la responsabilità contrattuale nei
                        confronti dell’Utente.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">6.11 Attività di fornitori terzi (chiarimento di distinzione)</h4>
                    <p>
                        Le attività offerte da fornitori terzi indipendenti restano disciplinate integralmente dai paragrafi 6 e
                        seguenti delle presenti CG.
                    </p>
                    <p>
                        In tali casi TicinoWild opera esclusivamente quale intermediario tecnico della piattaforma e non
                        assume alcuna responsabilità per l’organizzazione, l’esecuzione o la qualità delle attività fornite da
                        terzi.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">7. Attività a pagamento non prenotabili</h4>
                    <p>
                        Alcune attività a pagamento non possono essere prenotate tramite la piattaforma TicinoWild. In questi
                        casi eccezionali, nel limite del possibile, TicinoWild fornirà indicazione sul prezzo dei/l servizi/o e su
                        come effettuare l’acquisto esternamente alla piattaforma.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">8. Shop</h4>
                    <h4 className="text-[#225424]">8.1. Pagamenti</h4>
                    <p>
                        Il pagamento può essere effettuato tramite i metodi di pagamento indicati nella procedura d'ordine
                        all’interno dello shop di TicinoWild.
                        Eventuali costi associati al metodo di pagamento scelto o commissioni applicate (ad esempio per
                        tassi di cambio) dal fornitore del mezzo di pagamento scelto sono a carico dell’Utente.
                        L’Utente è considerato il solo responsabile per ogni ordine e pagamento effettuato tramite il suo conto
                        utente. TicinoWild declina ogni responsabilità per ordini e pagamenti illeciti o non autorizzati effettuati
                        da parte di terzi dall’account personale dell’Utente. Tali ordini e pagamenti sono considerati da
                        TicinoWild come effettuati da parte dell’Utente.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">8.2. Sicurezza e protezione dei dati</h4>
                    <p>
                        In fase di acquisto sullo shop di TicinoWild, all’Utente viene richiesto di inserire i propri dati di
                        contatto, pagamento e spedizione. L'Utente è tenuto a fornire informazioni corrette, aggiornate e
                        complete. Le informazioni di contatto e spedizione vengono utilizzate per la spedizione degli articoli
                        acquistati.
                    </p>
                    <p>
                        Per la gestione dei pagamenti TicinoWild utilizza Stripe. Maggiori informazioni sulla gestione delle
                        transazioni, nonché sulla privacy policy di Stripe e sulla gestione dei cookie da parte del loro sito web
                        è disponibile su www.stripe.com.
                    </p>
                    <p>
                        TicinoWild non ha accesso diretto ai dati di pagamento forniti dall’Utente durante il processo di
                        pagamento. Tutte le transazioni sono gestite tramite Stripe, una piattaforma di pagamento sicura e
                        certificata, che garantisce la protezione dei dati sensibili.
                        Di conseguenza, TicinoWild declina ogni responsabilità per eventuali furti, violazioni o utilizzi illeciti
                        dei mezzi di pagamento dell’Utente. Per qualsiasi problema relativo ai pagamenti, l’Utente è invitato a
                        contattare direttamente il gestore del proprio mezzo di pagamento.
                    </p>
                </div>


                <div>
                    <h4 className="text-[#225424]">8.3. Spedizione e costi di spedizione</h4>
                    <p>
                        TicinoWild spedisce dalla Svizzera e solamente verso la Svizzera, tramite Posta Svizzera.
                    </p>
                    <p>
                        I costi di spedizione sono a carico dell’Utente e vengono pagati al momento dell’acquisto.
                        L’ammontare dei costi di spedizione dipende dalle tariffe fissate dalla Posta Svizzera ed è indicato nel
                        riassuntivo dei costi al momento di conferma del pagamento.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">8.4. Riserva di proprietà</h4>
                    <p>
                        La proprietà degli articoli sarà trasferita all’acquirente solo quando TicinoWild avrà ricevuto il
                        completo pagamento di tutte le somme dovute per gli articoli, incluse le spese di spedizione. Tutti gli
                        articoli acquistati saranno trasportati e consegnati all’Utente dalla Posta Svizzera. Alla consegna, il
                        rischio connesso alla proprietà degli articoli sarà trasferito all’Utente.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">8.5. Tempi di spedizione</h4>
                    <p>
                        I tempi di spedizione dipendono dalla Posta Svizzera. TicinoWild declina ogni responsabilità circa
                        eventuali ritardi di spedizione, così come per mancata consegna dell’ordine a causa di cambio di
                        indirizzo, inesattezze nell’indirizzo fornito al momento dell’ordine o per altri fattori che possano
                        impedire la consegna da parte della Posta Svizzera. Si declina anche ogni responsabilità per furto
                        presso il domicilio a consegna avvenuta.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">8.6. Resi</h4>
                    <p>
                        È possibile restituire gli articoli entro 7 giorni e chiederne il rimborso scrivendo a info@ticinowild.ch,
                        indicando nell’e-mail il motivo del reso. I termini per restituire un prodotto si calcolano a partire dalla
                        data di spedizione. Nello specifico, fa fede la data in cui è stato apposto il timbro postale.
                        Le spese di spedizione sono a carico dell’Utente e non vengono rimborsate.
                        TicinoWild rimborserà l’Utente della somma pari al prezzo di acquisto dell’articolo per cui è stato
                        chiesto il reso, solo dopo aver ricevuto indietro l’articolo. Il reso non è possibile se l’articolo presenta
                        parti mancanti o danneggiate dall’Utente.
                    </p>
                    <p>
                        In caso di articoli arrivati danneggiati, è possibile chiederne la sostituzione gratuita entro 7 giorni
                        scrivendo a info@ticinowild e fornendo una prova fotografica del danno. Come sopra, per il calcolo dei
                        7 giorni fa fede il timbro postale. Per la sostituzione di articoli danneggiati, le spese di spedizione sono
                        da anticipare da parte dell’Utente e verranno in seguito rimborsate da TicinoWild. Nell’improbabilità
                        che l’articolo danneggiato non sia più disponibile (out of stock), TicinoWild provvederà al rimborso
                        completo del prezzo di acquisto dell’articolo.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">9. Nessuna garanzia in merito all’integrità e all’esattezza</h4>
                    <p>
                        Le informazioni pubblicate sul sito web di TicinoWild sono fornite esclusivamente per uso personale e
                        a scopi informativi. Esse possono essere modificate in qualunque momento e senza preavviso.
                        Sebbene TicinoWild abbia fatto tutto il necessario per assicurare l’attendibilità delle informazioni
                        contenute sulla sua piattaforma al momento della loro pubblicazione, né TicinoWild né i suoi partner
                        contrattuali possono dare alcuna assicurazione o garanzia esplicita o implicita (anche verso terzi) in
                        merito all’esattezza, l’attendibilità, l’integrità, la completezza e l’attualità delle informazioni presenti
                        sul sito web di TicinoWild.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">10. Limitazione di responsabilità</h4>
                    <p>
                        TicinoWild non si assume alcuna responsabilità in merito a perdite o danni di qualsiasi genere - diretti,
                        indiretti, o consequenziali - che risultino a seguito dell'utilizzo o dell'accesso al sito web TicinoWild o
                        da collegamenti ipertestuali (link) che portano a siti web di terzi. TicinoWild non garantisce che il
                        funzionamento costante del suo sito web né che le singole parti del suo sito funzionino perfettamente.
                        TicinoWild declina qualsiasi responsabilità in merito a manipolazioni del sistema informatico
                        dell'utente internet da parte di persone non autorizzate. TicinoWild segnala esplicitamente il rischio di
                        eventuali virus e la possibilità di mirati attacchi di hackers. Al fine di combattere i virus, si consiglia di
                        utilizzare versioni aggiornate dei browser internet e di installare software antivirus costantemente
                        aggiornati. Si consiglia di non aprire né e-mail di provenienza sconosciuta, né inattesi allegati e-mail.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">11. Link a siti di terze parti</h4>
                    <p>
                        La piattaforma TicinoWild può contenere collegamenti ipertestuali a siti web gestiti da parti diverse da
                        TicinoWild. Tali collegamenti ipertestuali vengono forniti esclusivamente a scopo di riferimento.
                        TicinoWild non esercita alcun controllo su tali siti e non è responsabile dei contenuti o della tutela
                        della privacy o altre prassi di tali siti web. Inoltre, è responsabilità dell'Utente assumere precauzioni
                        per garantire che i link selezionati o i software scaricati (da questo o altri siti web) siano privi di
                        elementi quali virus, cavalli di Troia, difetti e altri elementi di natura dannosa.
                        Si consiglia di leggere i termini e condizioni e la normativa sulla privacy di siti e app di terze parti
                        visitati, poiché essi applicano regole e autorizzazioni sul trattamento dei dati che potrebbero differire
                        da quelli applicati da TicinoWild.
                        Collegarsi o consultare siti web o app di terzi è ad esclusivo rischio e pericolo dell’Utente.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">12. Diritti d'autore e diritti dei marchi</h4>
                    <p>
                        L’intero contenuto dei servizi digitali di TicinoWild è protetto dal diritto d’autore. Tutti i diritti
                        appartengono a TicinoWild o a terzi. Gli elementi presenti sul sito web di TicinoWild è liberamente
                        accessibile solo a scopo di esplorazione delle risorse disponibili sui server (browsing). La riproduzione
                        del materiale o di parti di esso in forma scritta o elettronica è consentita solo citando espressamente
                        la fonte TicinoWild o la fonte citata sulla piattaforma nel caso in cui il contenuto sia di proprietà di
                        terzi. Sono vietati la riproduzione, la trasmissione, la modifica, l’interconnessione o l’utilizzo del sito
                        web di TicinoWild, rispettivamente dei loro contenuti, per scopi pubblici o commerciali senza il previo
                        consenso di TicinoWild o dei proprietari espressamente indicati (nel caso di contenuti di proprietà di
                        terzi). L'utilizzo di strumenti che richiamano, indicizzano e/o trasmettono in modo sistematico e
                        automatizzato il contenuto del sito web TicinoWild (ad esempio, i cosiddetti spider, crawler e altri
                        strumenti automatici) è particolarmente vietato.
                    </p>
                    <p>
                        I diversi nomi e loghi presenti sul sito web di TicinoWild sono di regola marchi registrati e protetti. Ogni
                        elemento costitutivo del sito di TicinoWild non sottintende in alcun modo la concessione di una
                        licenza o di un diritto all’utilizzo di un’immagine, di un marchio registrato o di un logo. Lo scaricamento
                        o la copiatura del sito web di TicinoWild o di parti di essi non implicano la cessione o il trasferimento di
                        alcun tipo di diritto concernente il software o gli elementi presenti sul sito di TicinoWild. TicinoWild si
                        riserva tutti i diritti per quanto riguarda tutti gli elementi presenti sul sito web di TicinoWild, ad
                        eccezione dei diritti appartenenti a terzi.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">13. Informativa sulla Privacy</h4>
                    <p>
                        La presente informativa sulla privacy descrive come TicinoWild raccoglie, utilizza e protegge i dati
                        personali degli Utenti del proprio sito web, in conformità con la Legge federale sulla protezione dei dati
                        (LPD) e, ove applicabile, il Regolamento generale sulla protezione dei dati (GDPR) dell’Unione Europea.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">13.1. Titolare del trattamento</h4>
                    <p>
                        Il titolare del trattamento dei dati è TicinoWild, contattabile all’indirizzo e-mail: info@ticinowild.ch.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">13.2. Dati raccolti</h4>
                    <p>
                        TicinoWild raccoglie dati personali solo nella misura necessaria per fornire i propri servizi. I dati
                        raccolti possono includere:
                    </p>
                    <ul className="list-disc pl-5">
                        <li>dati identificativi (nome, cognome)</li>
                        <li>dati di contatto (e-mail, numero di telefono)</li>
                        <li>dati di prenotazione (attività selezionate, partecipanti, preferenze)</li>
                        <li>dati relativi agli ordini nello shop (indirizzo di spedizione, storico acquisti)</li>
                        <li>dati tecnici (indirizzo IP, browser, dispositivo)</li>
                        <li>dati forniti volontariamente tramite moduli o comunicazioni</li>
                    </ul>
                </div>

                <div>
                    <h4 className="text-[#225424]">13.3. Finalità del trattamento</h4>
                    <p>I dati personali sono trattati per le seguenti finalità:</p>
                    <p><strong>a) Erogazione dei servizi</strong></p>
                    <ul className="list-disc pl-5">
                        <li>creazione e gestione dell’account utente</li>
                        <li>gestione delle prenotazioni e degli ordini</li>
                        <li>comunicazioni relative ai servizi</li>
                    </ul>
                    <p><strong>b) Obblighi legali</strong></p>
                    <ul className="list-disc pl-5">
                        <li>conservazione contabile e fiscale</li>
                        <li>gestione di eventuali obblighi normativi</li>
                    </ul>
                    <p><strong>c) Miglioramento del servizio e analisi</strong></p>
                    <ul className="list-disc pl-5">
                        <li>analisi dell’utilizzo della piattaforma</li>
                        <li>miglioramento delle funzionalità</li>
                    </ul>
                    <p><strong>d) Marketing (newsletter)</strong></p>
                    <p>
                        L’invio di comunicazioni promozionali e newsletter avviene esclusivamente su iscrizione volontaria e
                        separata da parte dell’Utente tramite apposito modulo disponibile sul sito web.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">13.3 bis. Base giuridica del trattamento</h4>
                    <p>
                        TicinoWild tratta i dati personali esclusivamente quando ciò è necessario per fornire i propri servizi o
                        quando sussiste un altro motivo legittimo previsto dalla legge.
                    </p>
                    <p>In particolare, i dati possono essere trattati nei seguenti casi:</p>
                    <ul className="list-disc pl-5">
                        <li>per l’esecuzione dei servizi richiesti dall’Utente (ad esempio account, prenotazioni, ordini e pagamenti)</li>
                        <li>per adempiere a obblighi legali, in particolare fiscali e contabili</li>
                        <li>sulla base del consenso dell’Utente, ad esempio per l’invio di newsletter o comunicazioni promozionali</li>
                        <li>
                            per interessi legittimi di TicinoWild, come la sicurezza della piattaforma, la prevenzione di abusi e il
                            miglioramento dei servizi, nella misura in cui tali interessi prevalgano sui diritti dell’Utente
                        </li>
                    </ul>
                </div>

                <div>
                    <h4 className="text-[#225424]">13.4. Trasmissione a terzi</h4>
                    <p>I dati possono essere trasmessi a terzi esclusivamente quando necessario, in particolare:</p>
                    <ul className="list-disc pl-5">
                        <li>ai partner fornitori per l’organizzazione delle attività prenotate</li>
                        <li>a fornitori di servizi tecnici (es. hosting, email, analytics)</li>
                        <li>a fornitori di servizi di pagamento come Stripe</li>
                    </ul>
                    <p>
                        I partner fornitori possono utilizzare i dati esclusivamente per l’organizzazione dell’attività prenotata.
                        Qualsiasi altro utilizzo è vietato.
                    </p>
                    <p>
                        I partner fornitori sono tenuti a cancellare i dati personali entro 2 settimane dal termine dell’attività,
                        salvo eventuali obblighi legali di conservazione applicabili.
                    </p>
                    <p>
                        Alcuni fornitori utilizzati da TicinoWild possono avere sede al di fuori della Svizzera. In questi casi, i dati
                        personali possono essere trasferiti anche all’estero. TicinoWild si assicura che tali trasferimenti
                        avvengano in conformità con la legge applicabile e che sia garantito un livello adeguato di protezione
                        dei dati, ad esempio tramite accordi contrattuali o altre garanzie riconosciute.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">13.5. Pagamenti</h4>
                    <p>
                        I pagamenti sono gestiti tramite Stripe. TicinoWild non ha accesso diretto ai dati completi di pagamento
                        (es. numeri di carta di credito).
                    </p>
                    <p>
                        Stripe può trattare dati personali anche al di fuori della Svizzera o dello Spazio Economico Europeo. Il
                        trattamento avviene secondo le condizioni e le garanzie previste da Stripe.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">13.6. Conservazione dei dati</h4>
                    <p>
                        TicinoWild conserva i dati personali solo per il tempo necessario a soddisfare le finalità per cui sono
                        stati raccolti. TicinoWild adotta misure tecniche e organizzative adeguate per garantire la sicurezza dei
                        dati e prevenirne l’accesso non autorizzato.
                    </p>
                    <p>
                        Alcuni dati — in particolare quelli relativi a ordini, prenotazioni, fatture e pagamenti — possono essere
                        conservati per un periodo fino a 10 anni, in conformità agli obblighi legali previsti dal diritto svizzero. Al
                        termine dei periodi di conservazione applicabili, i dati vengono cancellati o anonimizzati.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">13.7. Diritti degli utenti</h4>
                    <p>Gli Utenti hanno il diritto di:</p>
                    <ul className="list-disc pl-5">
                        <li>accedere ai propri dati personali</li>
                        <li>richiedere la rettifica di dati inesatti</li>
                        <li>richiedere la cancellazione dei dati personali</li>
                        <li>limitare o opporsi al trattamento, nei limiti della legge</li>
                    </ul>
                    <p>Oltre ai diritti già indicati, l’Utente ha il diritto di:</p>
                    <ul className="list-disc pl-5">
                        <li>richiedere informazioni sui dati personali trattati</li>
                        <li>richiedere la rettifica o la cancellazione dei propri dati, nei limiti previsti dalla legge</li>
                        <li>opporsi a determinati trattamenti, quando previsto dalla normativa applicabile</li>
                        <li>revocare in qualsiasi momento il consenso dato, con effetto per il futuro</li>
                        <li>
                            presentare un reclamo all’autorità competente per la protezione dei dati (in Svizzera: Incaricato
                            federale della protezione dei dati e della trasparenza, IFDT).
                        </li>
                    </ul>
                    <p>
                        Per esercitare questi diritti, gli Utenti possono contattare TicinoWild all’indirizzo e-mail seguente:
                        info@ticinowild.ch
                    </p>
                    <p>
                        Si prega di notare che la cancellazione di alcuni dati personali (come ad esempio l’indirizzo e-mail) è
                        possibile solo con la cancellazione del proprio account utente. Questi dati sono indispensabili per
                        garantire la corretta funzionalità della piattaforma e dei servizi offerti, come ad esempio prenotare
                        un’attività. L’utente può cancellare il proprio account dalla propria pagina di profilo.
                    </p>
                    <p>
                        La cancellazione dei dati personali avviene nella misura in cui non sussistano obblighi legali o
                        contrattuali di conservazione. In particolare, TicinoWild può conservare determinati dati per adempiere
                        a obblighi legali (ad esempio obblighi contabili e fiscali).
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">13.8. Cancellazione dell’account</h4>
                    <p>L’Utente può cancellare il proprio account in qualsiasi momento.</p>
                    <p>
                        La cancellazione dell’account comporta la disattivazione dell’accesso e la cancellazione o
                        anonimizzazione dei dati non più necessari alla fornitura dei servizi.
                    </p>
                    <p>
                        Restano esclusi dalla cancellazione i dati che TicinoWild è tenuta a conservare per obblighi legali o
                        contrattuali.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">13.9. Cookie</h4>
                    <p>
                        Il sito web di TicinoWild utilizza i cookie per migliorare l'esperienza di navigazione dell’Utente e per
                        analizzare il traffico del sito. I cookie sono piccoli file di testo memorizzati sul dispositivo dell'Utente
                        che permettono al sito di riconoscere le visite successive e di raccogliere informazioni statistiche e di
                        personalizzazione.
                        TicinoWild utilizza cookie tecnici necessari per il funzionamento del suo sito web e, previo consenso
                        dell'Utente, potrebbe utilizzare cookie di profilazione e cookie di terze parti per fornire contenuti e
                        annunci personalizzati.
                        L'Utente può scegliere di accettare o rifiutare i cookie non essenziali tramite le preferenze nel banner
                        dei cookie. Continuando la navigazione senza modificare le impostazioni del browser, accetta l'utilizzo
                        dei cookie essenziali.
                        L’Utente può modificare o revocare in qualsiasi momento il consenso all’utilizzo dei cookie non
                        essenziali tramite le impostazioni dei cookie. Non acconsentire o ritirare il consenso all’uso dei cookie
                        non essenziali non compromette il funzionamento delle funzioni principali della piattaforma, ma può
                        limitare alcune funzionalità aggiuntive influendo negativamente sull’esperienza di navigazione.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">13.10. Dati tecnici di tracking e analisi</h4>
                    <p>
                        Al fine di ottimizzare il proprio sito web e compilare statistiche, TicinoWild raccoglie cosiddetti dati di
                        tracking che consentono di analizzare il comportamento di utilizzo degli Utenti. Tali dati di tracking non
                        consentono di individuare singoli utenti e pertanto di risalire alle singole persone. Il sito web di
                        TicinoWild utilizza Google Analytics, un servizio di analisi web fornito da Google Inc. («Google»).
                        Google Analytics utilizza dei cookie al fine di analizzare il comportamento e l’utilizzo di un sito web da
                        parte degli Utenti. Le informazioni generate dai cookie sull'utilizzo del sito web (indirizzo IP compreso)
                        verranno trasmesse a, e depositate presso i server di Google negli Stati Uniti. Google utilizzerà queste
                        informazioni allo scopo di tracciare ed esaminare l’utilizzo del sito web, compilare report sulle attività
                        del sito web per gli operatori del sito web e fornire altri servizi relativi alle attività del sito web e
                        all'utilizzo di Internet. Google può anche trasferire queste informazioni a terzi ove ciò sia imposto dalla
                        legge o laddove tali terzi trattino le suddette informazioni per conto di Google. Google non assocerà
                        l’indirizzo IP personale a nessun altro dato posseduto da Google. È possibile rifiutare di usare questo
                        tipo di cookie selezionando l'impostazione appropriata sul browser; si noti però che ciò potrebbe
                        impedire di utilizzare tutte le funzionalità del sito web di TicinoWild. Utilizzando i servizi digitali di
                        TicinoWild, gli Utenti acconsentono al trattamento dei dati da parte di Google per le modalità e i fini
                        sopraindicati.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">13.11. Trasmissione di e-mail ed e-newsletter</h4>
                    <p>
                        Registrandosi sul sito web di TicinoWild, l’Utente accetta di ricevere via e-mail le conferme di richiesta
                        di prenotazione di un’attività o di richiesta di acquisto di un articolo all’interno dello shop, così come
                        altre informazioni ritenute importanti per lui (come ad esempio modifiche sulle Condizioni generali di
                        utilizzo della piattaforma).
                    </p>
                    <p>
                        TicinoWild può inoltre inviare via e-mail una newsletter contenente ulteriori informazioni, come ad
                        esempio aggiornamenti sulla piattaforma, attività interessanti e offerte speciali. Per ricevere questo
                        tipo di e-mail l’Utente deve iscriversi al servizio.
                        È possibile disdire la newsletter in qualsiasi momento. Ogni newsletter contiene un link diretto che
                        effettua la disdetta in modo semplice e automatico. La registrazione alla piattaforma non comporta
                        l’iscrizione alla newsletter.
                    </p>
                    <p>
                        È importante notare che, di norma, la trasmissione delle e-mail avviene in forma non codificata,
                        comportando il rischio che i dati possano essere intercettati e letti da terzi.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">13.12. Protezione dei dati</h4>
                    <p>TicinoWild assegna grande importanza alla protezione dei dati personali.</p>
                    <p>
                        Per registrarsi sulla piattaforma di TicinoWild come Utenti e per effettuare prenotazioni sono necessari
                        alcuni dati personali dell’Utente, come ad esempio il nome e l’indirizzo e-mail.
                        Per quanto concerne le prestazioni fornite da terzi, immettendo i propri dati personali l’Utente
                        autorizza automaticamente TicinoWild a trasferire tali informazioni ai relativi fornitori di servizi. Tali
                        terzi possono anche risiedere all’estero.
                    </p>
                    <p>
                        I partner fornitori di TicinoWild sono tenuti a utilizzare i dati personali dell’Utente esclusivamente ai
                        fini di conferma ed organizzazione dell’attività prenotata. Qualsiasi altro uso dei dati personali è
                        ritenuto improprio e costituisce una violazione degli obblighi contrattuali tra TicinoWild e i suoi
                        fornitori partner. Al più tardi entro 2 settimane dal termine dell’attività, i partner fornitori sono tenuti a
                        cancellare i dati dell’Utente.
                    </p>
                    <p>
                        Si esclude espressamente la vendita a terzi di dati personali da parte di TicinoWild.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">13.13. Modifiche all’informativa sulla Privacy</h4>
                    <p>
                        La presente informativa sulla privacy può essere adattata nel corso del tempo, in particolare qualora
                        cambino i trattamenti di dati da parte di TicinoWild oppure entrino in vigore nuove disposizioni legali.
                        TicinoWild si impegna ad informare attivamente gli Utenti che hanno registrato presso la propria
                        piattaforma i propri dati di contatto in merito a eventuali modifiche sostanziali apportate, purché ciò
                        sia possibile senza uno sforzo sproporzionato. In generale, per i trattamenti di dati si applica la
                        versione aggiornata dell’informativa sulla Privacy di volta in volta in vigore all’inizio del trattamento in
                        questione.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">14. Modifiche delle CG</h4>
                    <p>
                        Le CG possono essere modificate in qualsiasi momento. In caso di modifiche e adeguamenti
                        significativi delle CG, svantaggiosi per l'Utente dopo la stipula del contratto, l'Utente verrà informato
                        delle modifiche e degli adeguamenti tramite una notifica o tramite e-mail. Se le modifiche e gli
                        adeguamenti delle CG sono pregiudizievoli per l'Utente, quest'ultimo può recedere dal contratto prima
                        dell'entrata in vigore delle modifiche e degli adeguamenti. Se non lo fa, accetta le modifiche. Le nuove
                        CG sostituiscono quindi integralmente le CG precedentemente in vigore.
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">15. Foro competente e diritto applicabile</h4>
                    <p>
                        Fatte salve altre disposizioni di legge, gli accordi relativi alle presenti CG sono disciplinati
                        esclusivamente dal diritto svizzero. Il foro competente per tutte le controversie che sorgono in
                        relazione al presente contratto è Lugano.
                    </p>
                </div>

                <p>
                    Per facilitare la lettura del presente documento, il genere maschile è usato per designare persone e
                    funzioni indipendentemente dal genere.
                </p>
                <p>
                    ©2024 TicinoWild. Tutti i diritti riservati.
                </p>
                <p>
                    Ultimo aggiornamento: 19.04.2026
                </p>

            </div>
        </PageContainer>
    )
}

export default UserTermsAndConditions
